var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#555555",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00132 4.75C8.66871 4.75 9.35298 4.81936 10.069 5.55014L10.4261 5.20021C9.57466 4.33117 8.72934 4.25 8.00132 4.25V4.75ZM8.00119 4.7503C6.20588 4.7503 4.75049 6.2057 4.75049 8.00101C4.75049 9.20538 5.40546 10.2568 6.37864 10.8184C6.85603 11.0939 7.40997 11.2514 8.00071 11.2514C9.79602 11.2514 11.2514 9.79604 11.2514 8.00073C11.2514 7.86266 11.3633 7.75073 11.5014 7.75073C11.6395 7.75073 11.7514 7.86266 11.7514 8.00073C11.7514 10.072 10.0724 11.7512 8.00119 11.7514V11.7517C7.32142 11.7517 6.68389 11.5709 6.13407 11.2547C5.00818 10.6074 4.25 9.39262 4.25 8.00073C4.25 7.99525 4.25018 7.98981 4.25052 7.98442C4.25946 5.92059 5.93527 4.2503 8.00119 4.2503V4.7503Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10779 5.60742L10.4205 5.60742L10.4205 4.29474",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshCircle);
export default __webpack_public_path__ + "static/media/refresh_circle.e198fc5cab6f831371a7996a4057b263.svg";
export { ForwardRef as ReactComponent };